import styled from "@emotion/styled"

export const SidebarItems = styled.div`
  background:var(--key);
`
